// Delivery countries for the checkout selector.
//
// Free-text was the old behaviour, which made the shipping zones unusable —
// "SG", "singapore" and a typo all had to resolve to the Singapore rate. The
// list is ISO 3166-1 alpha-2 so the stored value is stable; names are rendered
// by the browser (and fall back to the code on anything that lacks Intl).

const CODES =
  "AF AL DZ AD AO AG AR AM AU AT AZ BS BH BD BB BY BE BZ BJ BT BO BA BW BR BN BG BF BI " +
  "KH CM CA CV CF TD CL CN CO KM CG CD CR CI HR CU CY CZ DK DJ DM DO EC EG SV GQ ER EE " +
  "SZ ET FJ FI FR GA GM GE DE GH GR GD GT GN GW GY HT HN HK HU IS IN ID IR IQ IE IL IT " +
  "JM JP JO KZ KE KI KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MR MU MX " +
  "FM MD MC MN ME MA MZ MM NA NR NP NL NZ NI NE NG KP MK NO OM PK PW PS PA PG PY PE PH " +
  "PL PT QA RO RU RW KN LC VC WS SM ST SA SN RS SC SL SG SK SI SB SO ZA KR SS ES LK SD " +
  "SR SE CH SY TW TJ TZ TH TL TG TO TT TN TR TM TV UG UA AE GB US UY UZ VU VA VE VN YE " +
  "ZM ZW";

let displayNames = null;
try {
  displayNames = new Intl.DisplayNames(["en"], { type: "region" });
} catch {
  displayNames = null;
}

function nameFor(code) {
  if (!displayNames) return code;
  try {
    return displayNames.of(code) || code;
  } catch {
    return code;
  }
}

export const COUNTRIES = CODES.split(" ")
  .filter(Boolean)
  .map((code) => ({ code, name: nameFor(code) }))
  .sort((a, b) => a.name.localeCompare(b.name));

/** The name a country is stored and priced under. */
export function countryName(code) {
  const hit = COUNTRIES.find((c) => c.code === code);
  return hit ? hit.name : code || "";
}

/** Tolerate the free-text values saved before this list existed. */
export function codeForName(value) {
  const key = String(value || "").trim().toLowerCase();
  if (!key) return "";
  const hit = COUNTRIES.find(
    (c) => c.name.toLowerCase() === key || c.code.toLowerCase() === key
  );
  return hit ? hit.code : "";
}
